import { useState } from "react";
import { Menu, Target, X } from "lucide-react";

import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const links = [
  ["Portada", "#portada", "nav-home-link"],
  ["Semana", "#semana", "nav-week-link"],
  ["Eventos", "#eventos", "nav-events-link"],
  ["Crónicas y premiados", "#cronicas", "nav-chronicles-link"],
  ["Calendario", "#calendario", "nav-calendar-link"],
  ["Hemeroteca", "#hemeroteca", "nav-archive-link"],
  ["Galería", "#galeria", "nav-gallery-link"],
  ["Redes", "#redes", "nav-social-link"],
];

export function Navbar() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();

  return (
    <header className="fixed left-1/2 top-4 z-50 w-[calc(100%-1.5rem)] max-w-7xl -translate-x-1/2 rounded-full border border-white/12 bg-charcoal/58 shadow-[0_18px_60px_rgba(0,0,0,0.28)] backdrop-blur-2xl" data-testid="main-navigation">
      <nav className="flex h-16 items-center justify-between px-4 sm:px-6">
        <a href="#portada" className="group flex items-center gap-3" data-testid="nav-brand-link">
          <span className="grid h-10 w-10 place-items-center rounded-full border border-clay/50 bg-clay/15 text-clay transition-colors group-hover:bg-clay group-hover:text-charcoal">
            <Target className="h-5 w-5" />
          </span>
          <span>
            <span className="block font-display text-2xl leading-none tracking-wide">TODO<span className="text-clay">tiro</span></span>
            <span className="block font-mono text-[9px] uppercase tracking-[0.35em] text-slate-300">Al plato</span>
          </span>
        </a>

        <div className="hidden items-center gap-5 xl:gap-7 lg:flex">
          {links.map(([label, href, testId]) => (
            <a key={href} href={href} className="nav-link" data-testid={testId}>
              {label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-3 lg:flex">
          <Button asChild className="rounded-full border border-clay/40 bg-clay px-5 font-mono text-[10px] uppercase tracking-[0.22em] text-charcoal hover:bg-brass">
            <a href={user ? "#redaccion" : "#registro"} data-testid="nav-publish-link">{user ? "Panel redacción" : "Registro"}</a>
          </Button>
        </div>

        <button
          type="button"
          className="grid h-11 w-11 place-items-center rounded-full border border-white/15 text-slate-100 lg:hidden"
          onClick={() => setOpen((value) => !value)}
          aria-label="Abrir menú"
          data-testid="mobile-menu-button"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </nav>

      {open ? (
        <div className="absolute left-0 right-0 top-[calc(100%+0.75rem)] border border-white/10 bg-charcoal/95 p-5 shadow-2xl backdrop-blur-2xl lg:hidden" data-testid="mobile-navigation-menu">
          <div className="grid gap-4">
            {links.map(([label, href, testId]) => (
              <a key={href} href={href} onClick={() => setOpen(false)} className="nav-link text-base" data-testid={`${testId}-mobile`}>
                {label}
              </a>
            ))}
            <a href={user ? "#redaccion" : "#registro"} onClick={() => setOpen(false)} className="mt-2 border border-clay/40 bg-clay/10 px-4 py-3 font-mono text-xs uppercase tracking-[0.22em] text-clay" data-testid="nav-publish-link-mobile">
              {user ? "Panel redacción" : "Registro"}
            </a>
          </div>
        </div>
      ) : null}
    </header>
  );
}
